// extracted by mini-css-extract-plugin
module.exports = {"tabBox":"tabBox___3n-Jc","item_box":"item_box___3hrqO","item_content":"item_content___1vLP5","item_title":"item_title___8ybSc","item_subtitle":"item_subtitle___1BxO5"};